import React, { useState } from 'react';
import { useSelector } from 'react-redux';
// Selectors
import { selectAccountsSettings } from 'store/accounts/accountsSelectors';
// MUI
import { Box, Tabs, Tab } from '@mui/material';
// Components
import PaymentCreditCardForm from './PaymentCreditCardForm';
import PaymentCheckForm from './PaymentCheckForm';

type Props = {
  reservationId: number,
  onClose: () => void,
}

const IroquoisPaymentForms:React.FC<Props> = ({ reservationId, onClose }) => {
  const { paymentCreditCardEnabled, paymentAchEnabled } = useSelector(selectAccountsSettings);
  const [tab, setTab] = useState(paymentCreditCardEnabled ? 0 : 1);

  const handleChangeTab = (_: React.SyntheticEvent, value: number) => {
    setTab(value);
  };

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper', p: { xs: 2, md: 4 } }}>
      <Tabs value={tab} onChange={handleChangeTab} centered>
        {paymentCreditCardEnabled && <Tab value={0} sx={{ fontSize: '20px' }} label="Credit card payment" />}
        {paymentAchEnabled && <Tab value={1} sx={{ fontSize: '20px' }} label="Check payment" />}
      </Tabs>

      {tab === 0 && paymentCreditCardEnabled && <PaymentCreditCardForm reservationId={reservationId} onClose={onClose}  />}
      {tab === 1 && paymentAchEnabled && <PaymentCheckForm reservationId={reservationId} onClose={onClose}  />}
    </Box>
  );
}

export default IroquoisPaymentForms;
